// extracted by mini-css-extract-plugin
module.exports = {"container":"selectCustomRoleDropdown_container__3CA8P"};